// extracted by mini-css-extract-plugin
export default {"container":"categories_container__fvnc7","categories":"categories_categories__tVr7c","category":"categories_category__Aal8D","active":"categories_active__2PZuD"};